export const GoogleMapsAPIKey = 'AIzaSyCb_xtYTdy7pw6ucJzYxQAyO6hD8BuRvh0';
// export const GoogleMapsAPIKey = 'AIzaSyDC18J6jkHyc8hlJTusIpxLGIqSZXwDIOc';
export const GoogleTagsKey = 'G-64QHVGGD88';
export const GoogleCaptchaKey = '6Le9EBMsAAAAADHBlz9lBt8XS3E2fA95ghFE-XGU';
export const GoogleOauthID = '148297267474-vf7ipm9upfdtt157p5r4i4gtc5nctuo4.apps.googleusercontent.com';